/**
 * No-photo avatar: the official Sweet Listeners ear-heart on a circle the
 * member picks (6 choices, from Sam's reference image). A real photo always
 * wins; the photo stays optional. Choice lives in profile publicData.avatarHeart.
 */

export const HEART_AVATAR_MARK = '/static/branding/sweet-listeners-ear-heart.png';
export const HEART_AVATAR_FIELD = 'avatarHeart';

/** Order = Sam's reference grid: row by row, left then right. */
export const HEART_AVATAR_OPTIONS = [
  { key: 'blush', labelId: 'HeartAvatar.option.blush', background: '#faeef3' },
  { key: 'white', labelId: 'HeartAvatar.option.white', background: '#ffffff', ring: true },
  { key: 'rose', labelId: 'HeartAvatar.option.rose', background: '#f9e7ee' },
  { key: 'sky', labelId: 'HeartAvatar.option.sky', background: '#e8f4fc' },
  {
    key: 'pinkGlow',
    labelId: 'HeartAvatar.option.pinkGlow',
    background: 'linear-gradient(180deg, #ef9fd0 0%, #f6d9e9 50%, #eaedf5 100%)',
  },
  {
    key: 'blueGlow',
    labelId: 'HeartAvatar.option.blueGlow',
    background: 'linear-gradient(180deg, #a5d0f7 0%, #d8ebfa 50%, #f8fafd 100%)',
  },
];

export const HEART_AVATAR_KEYS = HEART_AVATAR_OPTIONS.map(o => o.key);

/** Brand defaults before a member picks: pink for talkers, blue for listeners. */
export const DEFAULT_TALKER_HEART = 'blush';
export const DEFAULT_LISTENER_HEART = 'sky';

export const isHeartAvatarKey = key => HEART_AVATAR_KEYS.includes(key);

export const heartAvatarOption = key =>
  HEART_AVATAR_OPTIONS.find(o => o.key === key) || HEART_AVATAR_OPTIONS[0];

const publicDataOf = user => user?.attributes?.profile?.publicData || {};

/**
 * The member's saved choice, or null when they never picked one.
 *
 * @param {Object} [user]
 * @returns {string|null}
 */
export const savedHeartAvatarKey = user => {
  const key = publicDataOf(user)[HEART_AVATAR_FIELD];
  return isHeartAvatarKey(key) ? key : null;
};

/**
 * Saved choice, else the brand default (blue for listeners, pink otherwise).
 *
 * @param {Object} [user]
 * @param {Object} [options]
 * @param {boolean} [options.listener] force listener default (listing context)
 * @returns {string}
 */
export const heartAvatarKeyOf = (user, { listener } = {}) => {
  const saved = savedHeartAvatarKey(user);
  if (saved) {
    return saved;
  }
  const userType = publicDataOf(user).userType;
  const isListener = listener === true || (listener !== false && userType === 'listener');
  return isListener ? DEFAULT_LISTENER_HEART : DEFAULT_TALKER_HEART;
};
